import { ScheduledAccess } from '../AccessRestriction/types';
import { Block } from '../../web/containers/Block/types';
import { GroupOptions, UserCommunityOptions } from '../PageGroup/types';

export const PAGE_SET_MANY = 'PAGE_SET_MANY';
export const PAGE_UPDATE_MANY = 'PAGE_UPDATE_MANY';
export const SET_PAGE_IS_COMMENT_REQUIRED = 'SET_PAGE_IS_COMMENT_REQUIRED';
export const SET_PAGE_SUBPAGE_LIST = 'SET_PAGE_SUBPAGE_LIST';
export const PAGE_DATA_FETCH_START = 'PAGE_DATA_FETCH_START';
export const PAGE_DATA_FETCH_SUCCESS = 'PAGE_DATA_FETCH_SUCCESS';
export const PAGE_DATA_FETCH_FAILED = 'PAGE_DATA_FETCH_FAILED';
export const CREATE_PAGE_SUCCESS = 'CREATE_PAGE_SUCCESS';
export const BLOCKPAGE_DATA_FETCH_SUCCESS = 'BLOCKPAGE_DATA_FETCH_SUCCESS';

export enum ActionTypes {
  BLOCKPAGE_DATA_FETCH_START = 'BLOCKPAGE_DATA_FETCH_START',
  BLOCKPAGE_DATA_FETCH_SUCCESS = 'BLOCKPAGE_DATA_FETCH_SUCCESS',
  BLOCKPAGE_DATA_FETCH_FAILED = 'BLOCKPAGE_DATA_FETCH_FAILED',
}

export type BlockpageDataFetchSuccessAction = {
  type: ActionTypes.BLOCKPAGE_DATA_FETCH_SUCCESS;
  groupOptions: GroupOptions;
  userCommunityOptions: UserCommunityOptions;
  pagePath: string;
  scheduledAccess: ScheduledAccess;
  blocks: Block[];
};
export type BlockpageDataFetchFailed = {
  type: ActionTypes.BLOCKPAGE_DATA_FETCH_FAILED;
  error: string;
  pagePath: string;
};
export type PageAction =
  | BlockpageDataFetchSuccessAction
  | BlockpageDataFetchFailed;
